import { Component, Input, OnInit,ViewEncapsulation,PipeTransform, Pipe, } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";


@Pipe({ name: 'safe' })
export class SafePipe_ implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-youtube-video',
  templateUrl: './youtube-video.component.html',
  styleUrls: ['./youtube-video.component.css']
})
export class YoutubeVideoComponent implements OnInit {

  @Input()
  video_id : string;

  video_url : string;

  constructor() { }

  ngOnInit(): void {
    this.video_url = "https://www.youtube.com/embed/" + this.video_id;
  }

}
